import makeDrivers from 'infrastructure/drivers/json';
import { Method } from '@ux/drivers';
import { DSTquery } from 'presentation/components/pages/CMPage/DSTContext';

const drivers = makeDrivers();

type Config = {
  brandId: string;
  includeTax: boolean;
};
const getSuggestions = (query: DSTquery, { brandId, includeTax }: Config) => {
  if (query.domainName !== '' && brandId) {
    const params = new URLSearchParams();
    params.append('query', query.domainName);
    params.append('length[max]', '63');
    params.append('unspun', query.exactMatch.toString());
    params.append('brandId', brandId);
    params.append('exchangeRate', '1.4');
    params.append('maxResults', '40');
    params.append('bundle[minSize]', '2');
    params.append('bundle[maxSize]', '3');
    params.append('includeTax', includeTax.toString());

    return drivers({
      url: `/api/dst/v2/getSuggestions?${params.toString()}`,
      method: Method.GET,
    });
  }
};

export default getSuggestions;
